import React from 'react';
import { CheckCircle2, Shield, CreditCard, Smartphone } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-dark text-white pt-8 pb-12 md:pt-20 md:pb-32 overflow-hidden" data-id="element-238">
      {/* Background subtle pattern/gradient */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary via-dark to-dark" data-id="element-239"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-240">
        <div className="text-center max-w-4xl mx-auto" data-id="element-241">
          <div className="inline-block bg-primary/20 border border-primary/50 text-primary-light px-3 py-1 rounded-full md:text-sm font-bold tracking-wide uppercase mb-4 md:mb-6 text-[10px]" data-id="element-242">
            Para Instructores de Fútbol en Argentina 🇦🇷
          </div>
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-black leading-tight mb-4 md:mb-6 tracking-tight" data-id="element-243">
            Todo tu año de <br className="hidden md:block" data-id="element-244" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-yellow-200 to-gold bg-[length:200%_auto] animate-shimmer" data-id="element-245">
              Fútbol Resuelto
            </span>
          </h1>

          {/* Product Image — 70% size, centered */}
          <div className="flex justify-center mb-4 md:mb-6 relative" data-id="element-246">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full" data-id="element-247"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7gFUv7XmcScmbWPkzd7xSg/heylloyd-image-1776899878126-Photoroom.png" alt="Megapack Fútbol Resuelto" className="relative z-10 w-[70%] max-w-lg h-auto drop-shadow-2xl" data-id="element-248" />
          </div>

          <p className="md:text-3xl font-semibold text-gray-200 mb-3 md:mb-4 text-[14px]" data-id="element-249">
            Todo tu año de entrenamientos resuelto.
          </p>
          <p className="md:text-xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto text-[12px]" data-id="element-250">
            Tu año completo de fútbol listo: técnica, táctica, físico, arqueros,
            planificación y liderazgo. Sin improvisar. Sin perder horas pensando
            qué trabajar hoy.
          </p>
        </div>

        {/* Content & CTA — full width centered */}
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center" data-id="element-251">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-3 md:p-4 mb-4 md:mb-8 w-full" data-id="element-252">
            <p className="md:text-xl font-bold text-gold text-center text-[12px]" data-id="element-253">
              6 Tomos · 60+ Sesiones · 6 Bonos · Listo para usar.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-2 md:gap-4 mb-6 md:mb-10 w-full" data-id="element-254">
            {['PDF digital', 'Acceso inmediato', 'Todos los niveles', 'Instructores y entrenadores'].map((badge, i) => <div key={i} className="flex items-center justify-center space-x-1.5 text-xs md:text-base font-medium" data-id="element-255">
                <CheckCircle2 className="w-4 h-4 text-primary-light flex-shrink-0" data-id="element-256" />
                <span data-id="element-257">{badge}</span>
              </div>)}
          </div>

          <Button variant="gold" size="lg" fullWidth onClick={scrollToPricing} className="mb-4 md:mb-6 text-base md:text-2xl" data-id="element-258">
            💥 QUIERO MI MEGAPACK AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm text-gray-300 font-medium w-full" data-id="element-259">
            <div className="flex items-center" data-id="element-260">
              <Shield className="w-3.5 h-3.5 mr-1" data-id="element-261" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-262">
              <CreditCard className="w-3.5 h-3.5 mr-1" data-id="element-263" /> Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-264">
              <Smartphone className="w-3.5 h-3.5 mr-1" data-id="element-265" /> Mercado Pago | Tarjeta
            </div>
          </div>
        </div>

        {/* Social Proof Bar */}
        <div className="mt-8 md:mt-16 pt-6 md:pt-8 border-t border-white/10 flex flex-wrap justify-center items-center gap-4 md:gap-12 text-xs md:text-base font-bold text-gray-200" data-id="element-266">
          <div className="flex items-center" data-id="element-267">👥 +300 instructores</div>
          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-500" data-id="element-268"></div>
          <div className="flex items-center" data-id="element-269">📚 6+6 Tomos + Bonos</div>
          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-500" data-id="element-270"></div>
          <div className="flex items-center" data-id="element-271">⭐ 4.9/5</div>
          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-500" data-id="element-272"></div>
          <div className="flex items-center" data-id="element-273">🇦🇷 Todo el país</div>
        </div>
      </div>
    </section>;
}